import NewRetailPrescription from "../../../../components/@documents/retail_prescriptions/NewRetailPrescription";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailPrescriptionNewPage() {

    return (
        <NewRetailPrescription 
            routeType={routeTypes.admin}
        />
    )
}